import _ from "lodash";
import { useEffect, useState } from "react";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { MyTeamIcon } from "src/components/ui-icons/menu/myTasks";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { myTasks5WayListName } from "src/api/config/myTasks5Way.config";
import MyTeamTable from "src/components/tables/MyTeamTable.mobile";
import { myTasksIncidentstListName } from "src/api/config/myTasksInc.config";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import Сancel from "src/components/ui-icons/buttons/Сancel";
import CheckListsMain from "../checkList/CheckList.mobile.team";
import ActionsMainPage from "../components/actionsMainPage/actionsMainPage.mobile";
import List5WayMainPage from "../components/list5WayMainPage/list5WayMainPage.mobile";
import ListIncMainPage from "../components/listIncMainPage/listIncMainPage.mobile";
import { actionsStatus, fiveWhyStatus, FiveWhyType, incStatus } from 'src/api/config/systemSwitch';
import moment from "moment";
import Audits5sMainPage from "../components/audits5sMainPage/audits5sMainPage.mobile";
import { extractStrapiData, fetchTeam5SCards } from "../api/api";

export default function MyTeamPage() {
    const [team, setTeam] = useState<any>([]);
    const dispatch = useAppDispatch();
    const [customLoading, setCustomLoading] = useState(true);
    const currentUser = useAppSelector(selectCurrentUser);
    const [teamEmail, setTeamEmail] = useState<string>("");
    const users: any = useAppSelector(selectUsers);
    const [openComponentId, setOpenComponentId] = useState<string>('checklist-main');

    useEffect(() => {
        setCustomLoading(true);
        setTeam([]);
        if (currentUser.reports && currentUser.reports.length > 0) {
            let reportsEmailFilter: string[] = [];
            let reportsEmail: string[] = [];
            reportsEmailFilter = currentUser.reports.map((accountName: string) => `${accountName.split("|")[accountName.split("|").length - 1].toLowerCase().trim()}*`);
            reportsEmail = currentUser.reports.map((accountName: string) => accountName.split("|")[accountName.split("|").length - 1].toLowerCase().trim());
            dispatch(addUsers([..._.uniqWith(reportsEmail, _.isEqual)]));
            getItemsRequest({
                listName: myTaskActionsListName,
                filters: { ResponsibleEmail: reportsEmailFilter, Status: [actionsStatus.notStart, actionsStatus.process, actionsStatus.old] },
                sortOrder: { name: "ID", desc: true },
            }).then((results: any) => {
                const { items } = results;
                const allActions = [...items];
                getItemsRequest({ listName: myTasks5WayListName, filters: { "AuthorEmail": reportsEmailFilter, Status: [fiveWhyStatus.process, fiveWhyStatus.old], Type5Way: FiveWhyType } }).then((results: any) => {
                    const { items } = results;
                    const all5WhyAuthors = [...items];
                    getItemsRequest({ listName: myTasks5WayListName, filters: { "Editors": reportsEmailFilter, Status: [fiveWhyStatus.process, fiveWhyStatus.old], Type5Way: FiveWhyType } }).then((results: any) => {
                        const { items } = results;
                        const all5WhyEditors = [...items];
                        getItemsRequest({ listName: myTasks5WayListName, filters: { "Editors": reportsEmailFilter, Status: [fiveWhyStatus.process, fiveWhyStatus.old], Type5Way: 'DeviationReport' } }).then((results: any) => {
                            const { items } = results;
                            const allDeviationReportEditors = [...items];
                            getItemsRequest({ listName: myTasks5WayListName, filters: { "AuthorEmail": reportsEmailFilter, Status: [fiveWhyStatus.process, fiveWhyStatus.old], Type5Way: 'DeviationReport' } }).then((results: any) => {
                                const { items } = results;
                                const allDeviationReportAuthors = [...items];
                                getItemsRequest({
                                    listName: myTasksIncidentstListName,
                                    filters: { Questions: [`"IncidentOption":"Несоответствие"`], ResponsibleEmail: reportsEmailFilter, Status: [incStatus.process, incStatus.old] },
                                    sortOrder: { name: "DateIncidents2", desc: true }
                                }).then((results: any) => {
                                    const { items } = results;
                                    const allN = [...items];
                                    getItemsRequest({
                                        listName: myTasksIncidentstListName,
                                        filters: { Questions: [`"IncidentOption":"Инцидент"`], ResponsibleEmail: reportsEmailFilter, Status: [incStatus.process, incStatus.old] },
                                        sortOrder: { name: "DateIncidents2", desc: true }
                                    }).then((results: any) => {
                                        const { items } = results;
                                        const allInc = [...items];
                                        fetchTeam5SCards(reportsEmail)
                                            .then((resp: any) => extractStrapiData(resp) || [])
                                            .catch(() => [])
                                            .then((all5SCards: any[]) => {
                                        let dataTable: any = [];
                                        reportsEmail.forEach((email: string) => {
                                            dataTable = [...dataTable, {
                                                email,
                                                countActions: allActions.filter((action: any) => action.ResponsibleEmail === email).length,
                                                count5WhyAuthor: all5WhyAuthors.filter((fiveWhy: any) => fiveWhy.AuthorEmail === email).length,
                                                count5WhyEditor: all5WhyEditors.filter(item => item.Editors && item.Editors.split(';').length > 1 && item.Editors.split(';')[item.Editors.split(';').length - 1] === email).length,
                                                countDRAuthor: allDeviationReportAuthors.filter((dr: any) => dr.AuthorEmail === email).length,
                                                countDREditor: allDeviationReportEditors.filter(item => item.Editors && item.Editors.indexOf(email) !== -1).length,
                                                countAll5Why: all5WhyAuthors.filter((fiveWhy: any) => fiveWhy.AuthorEmail === email).length + all5WhyEditors.filter(item => item.Editors && item.Editors.split(';').length > 1 && item.Editors.split(';')[item.Editors.split(';').length - 1] === email).length,
                                                countAllDR: allDeviationReportAuthors.filter((dr: any) => dr.AuthorEmail === email).length + allDeviationReportEditors.filter(item => item.Editors && item.Editors.indexOf(email) !== -1).length,
                                                countN: allN.filter((n: any) => n.ResponsibleEmail === email).length,
                                                countInc: allInc.filter((inc: any) => inc.ResponsibleEmail === email).length,
                                                count5S: all5SCards.filter((card: any) =>
                                                    card.Auditor?.email?.toLowerCase() === email || card.CoAuditor?.email?.toLowerCase() === email
                                                ).length,
                                                countCheckList: 0
                                            }]
                                        });
                                        setTeam([...dataTable]);
                                        setCustomLoading(false);
                                            });
                                    }).catch(() => setCustomLoading(false));
                                }).catch(() => setCustomLoading(false));
                            }).catch(() => setCustomLoading(false));
                        }).catch(() => setCustomLoading(false));
                    }).catch(() => setCustomLoading(false));
                }).catch(() => setCustomLoading(false));
            }).catch(() => setCustomLoading(false));
        } else {
            setCustomLoading(false);
        }
    }, [currentUser]);

    return (
        <FlexRow className="scrollbar-none scrollbar-w-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
            <FlexCol className="grow w-[calc(100%-320px)]">
                <FlexCol className="w-full">
                    <FlexCol className="mb-[16px] tablet:mb-7.5 tablet:h-[76px] justify-between items-center shrink-0 w-full">
                        <FlexCol>
                            <nav className="flex justify-between w-full" aria-label="Breadcrumb">
                                <FlexCol className="grow">
                                    <ol className="inline-flex items-center">
                                        <li className="inline-flex items-center" aria-current="page">
                                            <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                                                <MyTeamIcon />
                                                <span>Моя команда</span>
                                            </div>
                                        </li>
                                    </ol>
                                </FlexCol>
                            </nav>
                        </FlexCol>
                        {teamEmail &&
                            <>
                            <span
                                className="text-sm text-[#637381] block w-full py-[16px]"
                                dangerouslySetInnerHTML={{
                                    __html: users[teamEmail] && users[teamEmail].jobTitle,
                                }}
                            />
                            <div className="flex items-center gap-2 w-full">
                                <UserAvatar
                                    avatar={users[teamEmail] && users[teamEmail].avatar}
                                    shortName={users[teamEmail] && users[teamEmail].shortName}
                                    displayName={users[teamEmail] && users[teamEmail].displayName}
                                    email={teamEmail}
                                />
                                <div className="flex flex-col flex-1 items-start justify-center">
                                    <span className="text-sm text-[#111928]">
                                        {users[teamEmail] && users[teamEmail].displayName}
                                    </span>
                                </div>
                                <div onClick={() => setTeamEmail("")} className="cursor-pointer">
                                    <Сancel />
                                </div>
                            </div>
                            </>
                        }
                    </FlexCol>
                    {teamEmail &&
                        <div className="py-[24px]">
                            <CheckListsMain
                              email={teamEmail}
                              jobTitleStr={users[teamEmail]?.jobTitleStr || users[teamEmail]?.jobTitle || ""}
                              page="myTeam"
                              minDate={moment().startOf("day").subtract(7, "year").toDate()}
                            />
                            <Audits5sMainPage
                                email={teamEmail}
                                id="audits-5s-main-page"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                            <ActionsMainPage
                                email={teamEmail}
                                id="actions-main-page"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                                />
                            <List5WayMainPage
                                email={teamEmail}
                                type={FiveWhyType}
                                user="AuthorEmail"
                                id="5way-author-email"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                            <List5WayMainPage
                                email={teamEmail}
                                type={FiveWhyType}
                                user="Editors"
                                id="5way-editors"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                            <List5WayMainPage
                                email={teamEmail}
                                type="DeviationReport"
                                user="AuthorEmail"
                                id="deviationreport-author-email"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                            <List5WayMainPage
                                email={teamEmail}
                                type="DeviationReport"
                                user="Editors"
                                id="deviationreport-editors"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                            <ListIncMainPage
                                email={teamEmail}
                                type={`"IncidentOption":"Несоответствие"`}
                                id="incident-option-discrepancy"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                            <ListIncMainPage
                                email={teamEmail}
                                type={`"IncidentOption":"Инцидент"`}
                                id="incident-option-incident"
                                openComponentId={openComponentId}
                                setOpenComponentId={setOpenComponentId}
                            />
                        </div> ||
                        <FlexRow>
                            <MyTeamTable
                                data={team}
                                setTeamEmail={setTeamEmail}
                                customLoading={customLoading}
                            />
                        </FlexRow>
                    }
                </FlexCol>
            </FlexCol>
        </FlexRow>
    );
}
